import axios from "axios";
import serialize from "json-form-data";
import { getApi } from "./utils";

export default {
    namespaced: true,

    state: {
        catalog: [],
    },

    mutations: {
        setCatalog(state, items) {
            state.catalog = items;
        },
    },

    actions: {
        async getCatalog(ctx) {
            const { url, commit } = getApi(ctx);
            const { data } = await axios.get(url("api/inventory-items/get-tree"));
            commit("setCatalog", data);
            return data;
        },

        async getItems(ctx, params) {
            const { url } = getApi(ctx);

            const { data, headers } = await axios.get(url("api/inventory/index"), {
                params: {
                    ...params,
                    expand: "inventoryHistories",
                },
            });
            const currentPage = +headers["x-pagination-current-page"];
            const pageCount = +headers["x-pagination-page-count"];
            const itemsPerPage = +headers["x-pagination-per-page"];
            const totalCount = +headers["x-pagination-total-count"];
            return {
                items: data,
                currentPage,
                pageCount,
                itemsPerPage,
                totalCount,
            };
        },

        async getStats(ctx, params) {
            const { url } = getApi(ctx);
            const { data } = await axios.get(
                url("api/inventory/index", {
                    ...params,
                    stat: 1,
                }),
            );
            return data;
        },

        async getItem(ctx, itemId) {
            const { url } = getApi(ctx);
            const { data } = await axios.get(url("api/inventory/view", { id: itemId }));
            return data;
        },

        async createItem(ctx, params) {
            const { url } = getApi(ctx);

            const { files, ...itemParams } = params;

            const formData = serialize(itemParams);

            files.forEach((file) => {
                formData.append("files[]", file);
            });

            const response = await axios.post(url("api/inventory/create"), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        },

        async updateItem(ctx, params) {
            const { url } = getApi(ctx);

            const { id, files, ...itemParams } = params;

            const formData = serialize(itemParams);

            files.forEach((file) => {
                formData.append("files[]", file);
            });

            const { data } = await axios.put(url("api/inventory/update", { id }), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return data;
        },

        async deleteItem(ctx, itemId) {
            const { url } = getApi(ctx);
            const { data } = await axios.delete(url("api/inventory/delete", { id: itemId }));
            return data;
        },

        async getItemHistory(ctx, itemId) {
            const { url } = getApi(ctx);
            const { data } = await axios.get(url("api/inventory-history/index", { id: itemId }));
            return data;
        },

        async action(ctx, params) {
            const { url } = getApi(ctx);

            const { files, ...itemParams } = params;

            const formData = serialize(itemParams);

            (files || []).forEach((file) => {
                formData.append("files[]", file);
            });

            const { data } = await axios.put(url("api/inventory-history/create"), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return data;
        },

        async getColumns(ctx) {
            const { url } = getApi(ctx);

            const { data } = await axios.get(url("api/inventory/columns"));

            return data;
        },

        async getUserColumns(ctx) {
            const { url, rootState } = getApi(ctx);
            const { userId } = rootState;

            const { data } = await axios.get(url("api/inventory/columns", { userId }));

            return data;
        },

        async saveUserColumns(ctx, columns) {
            const { url, rootState } = getApi(ctx);
            const { userId } = rootState;

            const { data } = await axios.put(url("api/inventory/save-user-columns"), {
                columns: JSON.stringify(columns),
                user_id: userId,
            });

            return data;
        },
    },
};
